import { render, staticRenderFns } from "./EditOrganizationList.vue?vue&type=template&id=576764f9"
import script from "./EditOrganizationList.vue?vue&type=script&lang=js"
export * from "./EditOrganizationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports